module.exports = __webpack_public_path__ + "img/gz.bf417db6.png";